import { render } from "./IntellifloOfficeDuplicateClientsTable.vue?vue&type=template&id=1f386c77&scoped=true"
import script from "./IntellifloOfficeDuplicateClientsTable.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficeDuplicateClientsTable.vue?vue&type=script&lang=js"

import "./IntellifloOfficeDuplicateClientsTable.vue?vue&type=style&index=0&id=1f386c77&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f386c77"]])

export default __exports__